import { type FC, type PropsWithChildren } from 'react';

import { Overlay } from './Overlay/Overlay';
import { IntroContext } from './context';
import { useIntroGuide } from './intro-guide';

const Intro: FC<PropsWithChildren> = ({ children }) => {
  const providerValue = useIntroGuide();
  const { isIntroActive } = providerValue;

  return (
    <IntroContext.Provider value={providerValue}>
      {isIntroActive && <Overlay />}
      {children}
    </IntroContext.Provider>
  );
};

export { Intro, IntroContext };
